import Vuex from "vuex";

import rootStore from "./modules/rootStore";
import plateCreate from "./modules/plateCreateStore";
import requests from "./modules/requestsStore";

// Create store
export default new Vuex.Store({
    namespaced: true,
    ...rootStore,
    modules: {
        plateCreate,
        requests,
    },
});
